// extracted by mini-css-extract-plugin
export default {"warning":"LessonWarnings_warning__EoD4E"};